export default __webpack_public_path__ + "static/media/avatar_120.a35bc2a6.png";